import { MARBLE_BG } from '../../config/backgrounds';
import React from 'react';
import { Box, Typography, Container, IconButton, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Instagram, Facebook } from '@mui/icons-material';
import BarionLogoStrip from '../Barion/BarionLogoStrip';

const socialLinks = [
  { icon: <Instagram />, label: 'Instagram', url: 'https://www.instagram.com/wedigo.hu/' },
  { icon: <Facebook />, label: 'Facebook', url: 'https://www.facebook.com/profile.php?id=61589355263973' },
];

const Footer = () => {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        backgroundImage: MARBLE_BG,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        color: 'white',
        py: 2,
        mt: 'auto',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: theme.palette.primary.dark,
          opacity: 0.8,
          zIndex: 0,
        },
        '& > *': {
          position: 'relative',
          zIndex: 1,
        }
      }}
    >
      <Container maxWidth="lg">
        {/* Barion-elfogadóhely feltétele: a fizetési módok logósora a főoldalon (a lábléc minden oldalon látszik) */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1.5 }}>
          <BarionLogoStrip variant="dark" height={{ xs: 28, sm: 36 }} />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mb: 1 }}>
          {socialLinks.map(({ icon, label, url }) => (
            <Tooltip key={label} title={label}>
              <IconButton
                component="a"
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                size="small"
                sx={{
                  color: 'rgba(255,255,255,0.7)',
                  '&:hover': { color: '#fff', backgroundColor: 'rgba(255,255,255,0.1)' },
                }}
              >
                {icon}
              </IconButton>
            </Tooltip>
          ))}
        </Box>
        <Typography variant="body2" align="center">
          © 2026 Wedigo. Minden jog fenntartva.
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, mt: 1 }}>
          <Link
            to="/adatvedelmi-nyilatkozat"
            style={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.75rem', textDecoration: 'none' }}
            onMouseEnter={e => e.target.style.color = '#fff'}
            onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.75)'}
          >
            Adatkezelési tájékoztató
          </Link>
          <Link
            to="/felhasznalasi-feltetelek"
            style={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.75rem', textDecoration: 'none' }}
            onMouseEnter={e => e.target.style.color = '#fff'}
            onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.75)'}
          >
            ÁSZF (Felhasználók)
          </Link>
          <Link
            to="/partneri-aszf"
            style={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.75rem', textDecoration: 'none' }}
            onMouseEnter={e => e.target.style.color = '#fff'}
            onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.75)'}
          >
            Partneri ÁSZF
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;